/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */

import {
  GET_PROCEDURE,
  LIST_WORKER_OUTPUTS_BY_PROCEDURE,
  PARSE_ALANG_TEXT
} from './queries/process';
import {
  GET_DEPARTMENT,
  LIST_DEPARTMENTS,
  LIST_ALL_DEPARTMENTS,
  LIST_DEPARTMENT_COLLABORATORS,
  GET_DEPARTMENT_HISTORY
} from './queries/department';
import {
  GET_LEARNED_ANSWER_BY_REQUEST_ANSWER_ID,
  LIST_DEPARTMENT_LEARNED_ANSWERS
} from './queries/learnings';
import { GET_WORKER } from './queries/playground';
import {
  GET_REQUEST,
  GET_REQUEST_ANSWER,
  LIST_REQUESTS_BY_PROCEDURE
} from './queries/request';
import { GET_OWNER_ORGANIZATION } from './queries/organization';
import { GET_FACT, GET_FACTS } from './queries/fact';
import { GET_DOWNLOAD_FROM_S3_URL, GET_UPLOAD_TO_S3_URL } from './queries/misc';
import { LIST_KCHAT_MESSAGES_BY_WORKER } from './queries/koncierge';

const Queries = {
  Fact() {
    return GET_FACT;
  },

  Facts() {
    return GET_FACTS;
  },

  Department() {
    return GET_DEPARTMENT;
  },

  ListUserDepartments() {
    return LIST_DEPARTMENTS;
  },

  ListDepartmentLearnedAnswers() {
    return LIST_DEPARTMENT_LEARNED_ANSWERS;
  },

  ListAllDepartments() {
    return LIST_ALL_DEPARTMENTS;
  },

  ListDepartmentCollaborators() {
    return LIST_DEPARTMENT_COLLABORATORS;
  },

  // Get department history for
  GetDepartmentHistory() {
    return GET_DEPARTMENT_HISTORY;
  },

  // Organization
  OwnerOrganization() {
    return GET_OWNER_ORGANIZATION;
  },

  // Get procedure
  Procedure() {
    return GET_PROCEDURE;
  },

  getRequestAnswer() {
    return GET_REQUEST_ANSWER;
  },

  getLearnedAnswerByRequestAnswerId() {
    return GET_LEARNED_ANSWER_BY_REQUEST_ANSWER_ID;
  },

  // Get worker
  Worker() {
    return GET_WORKER;
  },

  Request() {
    return GET_REQUEST;
  },

  RequestsByProcedure() {
    return LIST_REQUESTS_BY_PROCEDURE;
  },

  ParseAlangText() {
    return PARSE_ALANG_TEXT;
  },

  S3UploadLink() {
    return GET_UPLOAD_TO_S3_URL;
  },

  S3DownloadLink() {
    return GET_DOWNLOAD_FROM_S3_URL;
  },

  ListWorkerOutputsByProcedure() {
    return LIST_WORKER_OUTPUTS_BY_PROCEDURE;
  },

  ListKChatMessagesByWorkerQuery() {
    return LIST_KCHAT_MESSAGES_BY_WORKER;
  }
};

export default Queries;
